module.exports = __webpack_public_path__ + "images/emoji/fax.42e121ab8791e4229e1c.png";